import styled from "styled-components";

export const Container = styled.fieldset`
  border-radius: 5px;
  border: 2px solid rgba(83, 82, 82);
  margin-bottom: 10px;
  padding: 0 0 0 8px;
  box-sizing: border-box;
  background-color: #fff;
  display: flex;
  position: relative;
  align-items: center;
`;

export const StyledInput = styled.input`
  width: 99%;
  font-size: 18px;
  height: 30px;
  border: none;
  border-radius: 5px;
  padding-left: 8px;
  box-sizing: border-box;
  background-color: #fff;

  &:focus {
    outline: none;
  }
`;

export const Legend = styled.legend`
  display: flex;
  align-items: center;
`;

export const ViewPassword = styled.button`
  position: absolute;
  right: 2px;
  background-color: #fff;
  cursor: pointer;
  border: none;
  height: 100%;
`;
